import React from 'react'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import vThum from '../assets/vission.png'
import mThum from '../assets/eye.png'

export default function VisionandMission() {
    return (
        <section className="relative bg-gradient-to-r from-[#011F41] to-[#011F41] py-16 px-4 overflow-hidden">

            {/* Background Glow */}
            {/* <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-3xl rounded-full"></div>
            <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-500/20 blur-3xl rounded-full"></div> */}

            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className='p-7 rounded-[10px] text-white bg-[#011F41]/20 shadow-lg'style={{borderLeft:'5px solid #ddd'}}>
                    <img src={mThum} alt='' />
                    <h3 className='text-3xl font-bold pb-4 pt-3'>Our Mission</h3>
                    <p className='text-gray-300 leading-8'>To make short-term financial support more transparent, accessible, and digitally convenient for salaried professionals navigating expenses between salary cycles.</p>
                </div>
                <div className='p-7 rounded-[10px] text-white shadow-lg bg-[#FF7B0E]'style={{borderLeft:'5px solid #ddd'}}>
                    <img src={vThum} alt='' />
                    <h3 className='text-3xl font-bold pb-4'>Our Vision</h3>
                    <p className='text-white-300 leading-8'>Currently serving users across 20+ cities, B4Salary aims to expand to 50+ cities across India by the end of 2027 while making digital borrowing more transparent and accessible for salaried professionals.</p>
                </div>
            </div>
        </section>
    )
}
